import { render } from "./AdminCompaniesHouse.vue?vue&type=template&id=b17cc402&scoped=true"
import script from "./AdminCompaniesHouse.vue?vue&type=script&lang=js"
export * from "./AdminCompaniesHouse.vue?vue&type=script&lang=js"

import "./AdminCompaniesHouse.vue?vue&type=style&index=0&id=b17cc402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b17cc402"]])

export default __exports__